import { ErrorHandler, Injectable } from '@angular/core';
import { AppVersionService } from '@shared/services/app-version.service';
import { AppService } from '@shared/services/app.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private appVersionService: AppVersionService,
  ) {
  }

  handleError(error: Error) {
    if (!this.catchSpecificErrors(error)) {
      throw error;
    }
  }

  catchSpecificErrors(error: Error) {
    if (error?.message?.indexOf('ChunkLoadError') >= 0) {
      console.info('App propbably has been updated. Need reload page');
      this.appVersionService.forceShowUpdateSuggestion();
      return true;
    } else {
      return false
    }
  }
}
